import { FormField } from '.';
import { Component } from '../../helpers/compiler';

@Component({ className: 'js-form-field', observe: true })
export class FormFieldComponent {
	constructor(private element: HTMLInputElement | HTMLSelectElement) {
		new FormField(this.element);
	}
}
